var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.hasProspects ? _c('ModalNewProspectPrompt', {
    attrs: {
      "prospect": _vm.prospects[0]
    }
  }) : _vm._e(), _vm.hasProspects ? _c('ProspectRider', {
    attrs: {
      "prospect": _vm.prospects[0]
    },
    on: {
      "openProspect": _vm.openProspect
    }
  }) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }